export { ProductModalComponent } from './product-modal/product-modal.component';
export { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
export { WebHeaderComponent } from './web-header/web-header.component';
export { WebFooterComponent } from './web-footer/web-footer.component';
export { CartSumDisplayComponent } from './cart-sum-display/cart-sum-display.component';
export { TextFieldComponent } from './text-field/text-field.component';
